/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PaymentSessionDTO,
  PriceCurrencyDTO,
  ProductModel,
} from '../models/index';
import {
    PaymentSessionDTOFromJSON,
    PaymentSessionDTOToJSON,
    PriceCurrencyDTOFromJSON,
    PriceCurrencyDTOToJSON,
    ProductModelFromJSON,
    ProductModelToJSON,
} from '../models/index';

export interface ApiStripeCheckoutPostRequest {
    countryCode: string;
    priceId: string;
    successUrl: string;
    cancelUrl: string;
}

export interface ApiStripeProductsGetRequest {
    countryCode: string;
}

/**
 * 
 */
export class StripeApi extends runtime.BaseAPI {

    /**
     */
    async apiStripeAvailablepricesGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PriceCurrencyDTO>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/stripe/availableprices`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PriceCurrencyDTOFromJSON));
    }

    /**
     */
    async apiStripeAvailablepricesGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PriceCurrencyDTO>> {
        const response = await this.apiStripeAvailablepricesGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiStripeCheckoutPostRaw(requestParameters: ApiStripeCheckoutPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaymentSessionDTO>> {
        if (requestParameters['countryCode'] == null) {
            throw new runtime.RequiredError(
                'countryCode',
                'Required parameter "countryCode" was null or undefined when calling apiStripeCheckoutPost().'
            );
        }

        if (requestParameters['priceId'] == null) {
            throw new runtime.RequiredError(
                'priceId',
                'Required parameter "priceId" was null or undefined when calling apiStripeCheckoutPost().'
            );
        }

        if (requestParameters['successUrl'] == null) {
            throw new runtime.RequiredError(
                'successUrl',
                'Required parameter "successUrl" was null or undefined when calling apiStripeCheckoutPost().'
            );
        }

        if (requestParameters['cancelUrl'] == null) {
            throw new runtime.RequiredError(
                'cancelUrl',
                'Required parameter "cancelUrl" was null or undefined when calling apiStripeCheckoutPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['countryCode'] != null) {
            queryParameters['countryCode'] = requestParameters['countryCode'];
        }

        if (requestParameters['priceId'] != null) {
            queryParameters['priceId'] = requestParameters['priceId'];
        }

        if (requestParameters['successUrl'] != null) {
            queryParameters['successUrl'] = requestParameters['successUrl'];
        }

        if (requestParameters['cancelUrl'] != null) {
            queryParameters['cancelUrl'] = requestParameters['cancelUrl'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/stripe/checkout`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentSessionDTOFromJSON(jsonValue));
    }

    /**
     */
    async apiStripeCheckoutPost(requestParameters: ApiStripeCheckoutPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaymentSessionDTO> {
        const response = await this.apiStripeCheckoutPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiStripePortalsessionPostRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/stripe/portalsession`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async apiStripePortalsessionPost(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.apiStripePortalsessionPostRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiStripeProductsGetRaw(requestParameters: ApiStripeProductsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ProductModel>>> {
        if (requestParameters['countryCode'] == null) {
            throw new runtime.RequiredError(
                'countryCode',
                'Required parameter "countryCode" was null or undefined when calling apiStripeProductsGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['countryCode'] != null) {
            queryParameters['countryCode'] = requestParameters['countryCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/stripe/products`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProductModelFromJSON));
    }

    /**
     */
    async apiStripeProductsGet(requestParameters: ApiStripeProductsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ProductModel>> {
        const response = await this.apiStripeProductsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
